
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"6.535","height":"9.016"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-479.409 -279)","fill":"none","stroke":"#1473e6","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M485.236 285l-1.2 1.2-1.348 1.32-1.348-1.32-1.224-1.2"}}),_c('line',{attrs:{"y1":"8","transform":"translate(482.676 279.5)"}})])])
          )
        }
      }
    